import { useState } from "react";
import MainDashboardFilters from "../dashboardfilters/maindashboardfilters";
import MainTable from "../tables/maintable";
import MainSearch from "../dashboardfilters/mainsearch";
import SupervisorDashboardFilters from "../dashboardfilters/superadmindashboardfilters";
import SuperVisorSearch from "../dashboardfilters/supervisorsearch";
import WeeklyTable from "../tables/weeklytable";
import TableInfoModal from "../modals/tableinfomodal";

const Weekly=()=>{
    const [filterby,setFilterBy]=useState('No Grouping')
    const [infomodal,setInfoModal]=useState(false)
    const [selectedDateRange, setSelectedDateRange] = useState({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
  });
   const [isDateRangeOpen, setIsDateRangeOpen] = useState(false);
      return(<>
      <div className="sm:pt-7 sm:px-8 mb-12">
  
      <SupervisorDashboardFilters  isDateRangeOpen={isDateRangeOpen} setIsDateRangeOpen={setIsDateRangeOpen}
         setFilterBy={setFilterBy} selectedDateRange={selectedDateRange} setSelectedDateRange={setSelectedDateRange}/>
    
      <div className="mb-2">
      <SuperVisorSearch />   
      </div>
     
      <div className="flex gap-2">
  <button className="px-4 py-2 border-t-2 border-r-2 border-l-2 border-[#8B1818] bg-[white] rounded-t-[4px]">
    Engineering
  </button>
  <button className="px-4 py-2 border-t border-r border-l border-[#DBDBDB] bg-[#F2F2F2] rounded-t-[4px]">
    Construction
  </button>
  <button className="px-4 py-2 border-t border-r border-l border-[#DBDBDB] bg-[#F2F2F2] rounded-t-[4px]">
    I&E
  </button>
</div>

  <WeeklyTable filterby={filterby}/>
  
      </div>
      
      <TableInfoModal isOpen ={!true} setIsopen={setInfoModal}/>
  
      </>)
}
export default Weekly;